import pt from "@/store/i18n/pt"

const _I18N = {
  pt
}

export default _I18N
